module.exports = __webpack_public_path__ + "img/card-6.d91d090a.png";